// extracted by mini-css-extract-plugin
export var formContainer = "_kj-0";
export var message = "_kj-1";